import { isTokenExpired } from './tokenUtils'

export async function fetchWithAuth(url: string, options: RequestInit = {}) {
  const token = localStorage.getItem('token')

  if (!token || isTokenExpired()) {
    localStorage.removeItem('token')
    localStorage.removeItem('token_expires_at')
    window.location.href = '/login'
    return Promise.reject(new Error('Token expired'))
  }

  const res = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  })

  if (res.status === 401) {
    localStorage.removeItem('token')
    localStorage.removeItem('token_expires_at')
    window.location.href = '/login'
  }

  return res
}

// Public API utility function
export async function fetchWithoutAuth(url: string, options: RequestInit = {}) {
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  })
}
